// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"SupplierProfileAccountPage_bi-chevron-down__3IaMP","accountPageContainer":"SupplierProfileAccountPage_accountPageContainer__183PO"};